"use strict";

(function() {

	/***************************************
		Common methods
	***************************************/

	var vpWidth = function() { return Math.max(document.documentElement.clientWidth, window.innerWidth || 0); }
	var vpHeight = function() { return Math.max(document.documentElement.clientHeight, window.innerHeight || 0); }
	var isIE = function() { return document.body.classList.contains('is-ie'); };
	var isSafari = function() { return navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') == -1; }

	function debounce(func, delay) {
		var wait;

		delay = delay || 50;
		return (function() {
			var context = this,
				args = arguments;

			clearTimeout(wait);
			wait = setTimeout(function() {
				func.apply(context, args);
			}, delay);
		})();
	}


	/***************************************
		Main Events
	***************************************/

	var imgPreloader, logoCollapse, resizer;

	var init = function() {
		imgPreloader      = new ImagePreloader();
		logoCollapse      = new logoCollapser();
		resizer           = resizeBody();

		toggleHeaderMenu();
		alignHomeSections();
		sliders();
		registerMap();
		credits();
	}


	var resizeBody = function() {
		var changeHeight = function() {
			var root = document.documentElement,
				height = window.innerHeight,
				width  = vpWidth(),
				vw = 0.01 * document.body.clientWidth,
				vh = 0.01 * window.innerHeight;

			root.style.setProperty('--vw', vw + 'px');
			root.style.setProperty('--vh', vh + 'px');
			document.body.style.height = window.innerHeight + 'px';
		}

		setTimeout(changeHeight, 20);
		window.addEventListener('resize', changeHeight);

		return changeHeight;
	}




	/**************************************************
		Lazy Loading
	**************************************************/

	class ImagePreloader {
		constructor(wrapper) {
			this.wrapper = wrapper || document;
			this.images  = [].slice.call(this.wrapper.querySelectorAll('img.lazy'));

			this.prepareImages();
			this.checkVisibility();
			this.registerEvents();
		}


		prepareImages() {
			this.images.forEach(function(image) {
				if (image.nextElementSibling && image.nextElementSibling.tagName === 'NOSCRIPT')
					image.parentElement.removeChild(image.nextElementSibling);

				var parentWidth   = image.parentElement.scrollWidth,
					naturalWidth  = image.getAttribute('width'),
					naturalHeight = image.getAttribute('height'),
					newHeight     = naturalHeight * parentWidth / naturalWidth;

				image.style.height = newHeight  + 'px';
				image.removeAttribute('lazy');
			});
		}

		checkVisibility() {
			if (this.images.length == 0) return;

			debounce((function() {				
				var winWidth  = vpWidth(),
					winHeight = vpHeight(),
					factor    = 0.3;

				this.images = this.images.filter((function(image) {
					var clientRect = image.getBoundingClientRect();

					if (clientRect.top + clientRect.height >= -factor * winHeight &&
						clientRect.top < (1 + factor) * winHeight &&
						clientRect.left + clientRect.width >= -factor * winWidth &&
						clientRect.left < (1 + factor) * winWidth) {

						this.loadImage(image);
						return false;
					}

					return true;
				}).bind(this));
			}).bind(this));
		};

		loadImage(image) {
			if (!image || !image.classList.contains('lazy')) return;

			image.onload = function() {				
				image.classList.add('loaded');

				setTimeout(function() {
					image.classList.remove('lazy', 'loaded');
					image.removeAttribute('data-src');
					image.removeAttribute('data-srcset');
				}, 1000);
			}

			image.src    = image.dataset.src;
			image.srcset = image.dataset.srcset;
			image.style.height = '';
		}

		loadImagesNow(wrapper) {
			wrapper = wrapper || document;

			var imgs = wrapper.querySelectorAll('img.lazy');
			[].forEach.call(imgs, (function(img) {
				this.loadImage(img);
			}).bind(this));
		}

		registerEvents() {
			window.addEventListener('scroll', (function() { this.checkVisibility(); }).bind(this), { passive: false });
			window.addEventListener('resize', (function() { this.checkVisibility(); }).bind(this), false);
		}
	}



	/***************************************
		Logo collapse
	***************************************/

	class logoCollapser {
		constructor() {
			this.logo = document.querySelector('.header-logo');
			if (!this.logo) return;

			this.update();
			window.addEventListener('scroll', (function() { this.update(); }).bind(this));
			window.addEventListener('resize', (function() { this.update(); }).bind(this));
		}

		update() {
			var toCollapse = window.scrollY >= 0.1 * vpHeight();

			if (toCollapse)	this.collapse();
			else 			this.expand();
		}

		collapse() {
			if (this.logo.classList.contains('collapse'))
				this.logo.classList.add('has-collapsed');

			this.logo.classList.add('collapse');
		}

		expand() {
			if (this.logo.classList.contains('collapse'))
				this.logo.classList.add('has-collapsed');

			this.logo.classList.remove('collapse');
		}

	};



	/***************************************
		Align home sections
	***************************************/

	var alignHomeSections = function() {
		var elems = [].slice.call(document.querySelectorAll('.home-section-description'));
		if (elems.length == 0) return;

		var resize = function() {
			var maxHeight = 0;

			elems.forEach(elem => {
				elem.style.minHeight = '';
				maxHeight = Math.max(elem.offsetHeight, maxHeight);
			});

			elems.forEach(elem => elem.style.minHeight = maxHeight + 'px');
		}

		resize();
		window.addEventListener('resize', resize);
	}



	/***************************************
		Sliders
	***************************************/

	var sliders = function() {
		var elems = document.querySelectorAll('.slider');
		if (!elems) return;

		[].forEach.call(elems, function(elem) {
			var slider = new Slider(elem);
		});
	}


	class Slider {
		constructor(slider) {
			this.slider    = slider;
			this.build();
		};

		build() {
			if (!this.slider) return this.cancelBuild();

			this.slideContainer	= this.slider.querySelector('.slider-inner');
			if (!this.slideContainer) return this.cancelBuild();

			this.slides			 = [].slice.call(this.slideContainer.querySelectorAll('.slide'));
			this.total			 = this.slides.length;

			if (this.total < 2) return this.cancelBuild();

			this.navContainer	 = this.slider.querySelector('.slider-nav');
			this.counter         = this.slider.querySelector('.slider-counter .slide-no');
			this.duration        = this.slider.dataset.duration ? parseInt(this.slider.dataset.duration) : 0;
			this.durationMin     = this.slider.dataset.durationMin ? parseInt(this.slider.dataset.durationMin) : 0;
			this.durationMax     = this.slider.dataset.durationMax ? parseInt(this.slider.dataset.durationMax) : 0;
			this.current		 = 0;
			this.mobileThreshold = 700;
			this.sliderWidth     = 0;
			this.isSliding		 = false;

			imgPreloader.loadImagesNow(this.slider);
			this.registerEvents();
			this.resize();
			this.autostart();
		}

		cancelBuild() {
			if (this.slider)
				this.slider.classList.add('aborted');
		}

		registerEvents() {
			var swipeDetected = this.swipeDetected.bind(this);
			this.swiper = new SwipeDetect(this.slider, swipeDetected, { stagger: 200, vertical: false });

			if (this.navContainer) {
				this.navContainer.querySelector('.slider-arrow-prev').addEventListener('click', this.prevSlide.bind(this));
				this.navContainer.querySelector('.slider-arrow-next').addEventListener('click', this.nextSlide.bind(this));
			}

			window.addEventListener('resize', this.resize.bind(this));
			document.addEventListener('keydown', this.keydown.bind(this));
		}

		resize() {
			this.sliderWidth = this.slider.getBoundingClientRect().width;
			this.slideTo(0, true);
		}

		slideTo(target, force) {
			target = parseInt(target);
			if (!force && (this.isSliding || target === this.current)) return;

			this.isSliding = true;
			target = this.wrapAroundIndex(target);

			this.slideContainer.style.transform = 'translateX(-' + target * this.sliderWidth + 'px)';
			imgPreloader.checkVisibility();
			
			if (this.counter)
				this.counter.innerText = target + 1;
			this.current = target;
			this.isSliding = false;
		}


		wrapAroundIndex(index) {
			if (index < 0)				return this.total + index;
			if (index >= this.total)	return this.total - index;
			return index;
		}

		prevSlide() {
			this.slideTo(this.current - 1);
		}

		nextSlide() {
			this.slideTo(this.current + 1);
		}

		autostart() {
			let duration = this.duration;
			if (this.durationMin !== 0 && this.durationMax !== 0)
				duration = this.durationMin + Math.random() * (this.durationMax - this.durationMin);

			if (duration == 0) return;

			setTimeout((function() {
				this.nextSlide();
				this.autostart();
			}).bind(this), duration);
		}

		swipeDetected(e) {
			if (e.directionX == 0) return;				

			var directionDegrees = e.direction2D * 180 / Math.PI + 90;		// down: 0°, clockwise

			while (directionDegrees <=   0) directionDegrees += 360;
			while (directionDegrees >= 360) directionDegrees -= 360;

			var	isRight          = directionDegrees >= 225 && directionDegrees <= 315,
				isLeft           = directionDegrees >= 45  && directionDegrees <= 135;

			if (isRight) 	this.prevSlide();
			if (isLeft) 	this.nextSlide();
			if (isLeft || isRight) e.event.preventDefault();
		}

		keydown(e) {
			var key = e.keyCode;
			
			if (key == 37)	this.prevSlide();
			if (key == 39)	this.nextSlide();
		}
	}




	/***************************************
		Toggle header menu
	***************************************/

	var toggleHeaderMenu = function() {
		var header = document.querySelector('.header'),
			menu   = document.querySelector('.header-menu'),
			toggle = document.querySelector('.header-menu-toggle');
		if (!toggle) return;

		var items      = [].slice.call(document.querySelectorAll('.header-menu-item.has-children')),
			links      = [].slice.call(menu.querySelectorAll('.header-menu-item')),
			label      = toggle.querySelector('.header-menu-toggle-label'),
			labelClose = label.innerText,
			labelOpen  = label.dataset.close,
			isVisible  = false;

		var toggleMenu = function() {
			isVisible = !isVisible;
			header.classList.toggle('show-menu', isVisible);
			label.innerText = isVisible ? labelOpen : labelClose;
			if (isVisible)	logoCollapse.collapse();
			else			logoCollapse.expand();
		};

		var closeMenu = function() {
			isVisible = false;
			header.classList.remove('show-menu');
			label.innerText = labelClose;
			logoCollapse.expand();
		}

		var toggleItems = function() {
			items.forEach(function(item) {
				var top       = item.querySelector('.header-menu-item-top'),
					inner     = item.querySelector('.header-submenu'),
					maxHeight = inner.scrollHeight,
					isVisible = false;

				var toggleThisItem = function() {
					isVisible = !isVisible;
					item.classList.toggle('show-more', isVisible);
					inner.style.maxHeight = isVisible ? maxHeight + 'px' : '';
				};

				top.addEventListener('click', toggleThisItem);
			});
		};

		toggle.addEventListener('click', toggleMenu);
		links.forEach(l => l.addEventListener('click', closeMenu));
		toggleItems();		
	}







	/***************************************
		Register map
	***************************************/

	var registerMap = function() {
		var elem = document.querySelector('.module-arrival .map-container');
		if (!elem || jsData.mapbox == '') return;

		var container = elem.querySelector('.map-inner');

		if (typeof mapboxgl === 'undefined')
			return setTimeout(registerMap, 100);

		mapboxgl.accessToken = jsData.accessToken;

		var map = new mapboxgl.Map({
				attributionControl: false,
				center: [jsData.longitude, jsData.latitude],
				container: container,
				style: jsData.mapStyle,
				zoom: 6,
				maxBounds: [
					[-180, -90],
					[180, 90]
				],
			}),
			
			locations = convertToGeoJSON({
				address:	jsData.address,
				latitude:	jsData.latitude,
				longitude:	jsData.longitude,
			}),
			popup     = new mapboxgl.Popup({ offset: 25 }),
			lang      = document.documentElement.lang,
			language  = new MapboxLanguage({ defaultLanguage: lang.replace(/-(\S+)/g, '') });

		map.addControl(new mapboxgl.NavigationControl());
		map.addControl(language);

		map.on('load', function() {
			map.addSource('single-point', {
				type: 'geojson',
				data: locations
			});
		
			
			map.addLayer({
				id: 'point',
				source: 'single-point',
				type: 'circle',
				paint: {
					'circle-radius': 0
				}
			});
		});

		locations.features.forEach(function(marker, i) {
			var el = document.createElement('div');
			el.id = "marker-" + i;
			el.className = 'marker';

			new mapboxgl.Marker(el, { offset: [0, -23] })
				.setLngLat(marker.geometry.coordinates)
				.addTo(map);

			el.addEventListener('click', function(e) {
				createPopUp(marker);
				e.stopPropagation();
			});
		});

		var createPopUp = function(feature) {
			var popUps = elem.querySelectorAll('.mapboxgl-popup');

			if (popUps[0])
				popUps[0].remove();

			var popup = new mapboxgl.Popup({closeOnClick: false})
							.setLngLat(feature.geometry.coordinates)
							.setHTML(buildHTML(feature).outerHTML)
							.addTo(map);
		};


		var buildHTML = function(feature) {
			var listing      = document.createElement('div'),
				address      = listing.appendChild(document.createElement('div'));

			listing.className = 'map-search-result';
			address.innerHTML  = feature.properties.address;

			return listing;
		};
	}

	var convertToGeoJSON = function(locations) {
		locations = [locations];
		return {
			'type': 'FeatureCollection',
			'features': locations.map(function(location, index) {
				var props = Object.assign({}, location);
				props.id = index;
				delete props.latitude;
				delete props.longitude;

				return {
					'type': 'Feature',
					'geometry': { 'type': 'Point', 'coordinates': [parseFloat(location.longitude), parseFloat(location.latitude)] },
					'properties': props
				}
			})
		};
	};







	/***************************************
		Credits
	***************************************/

	var credits = function() {
		var credits = '**********\n\nThis website was designed by FRENDZ.CLUB.\nhttps://frendz.club/\n\nIt was built by Matthias Planitzer.\nwww.matthias-planitzer.de\n\n**********';
		console.log('%c' + credits, 'color: #00F; font-family: Akkurat, sans-serif; font-size: 14px;');	
	}





	/***************************************
		Swipe detect
	***************************************/

	class SwipeDetect {
		constructor(elem, callback, args) {
			var defaults = {
				minDistance:       50,
				addMouseEvents:    true,
				addDragDropEvents: true,
				horizontal:        true,
				vertical:          true,
				stagger:           100
			};

			this.elem      = elem;
			this.callback  = callback;
			this.args      = Object.assign(defaults, args);

			this.active    = false;
			this.eventType = null;
			this.lastPos   = { x: null, y: null };
			this.lastEmit  = Date.now();
			
			this.registerEvents();
		}

		destruct() {
			this.elem.removeEventListener('touchstart', this.fn.startTouch);
			this.elem.removeEventListener('touchmove',  this.fn.move);
			this.elem.removeEventListener('touchend',   this.fn.end);

			if (this.args.addMouseEvents) {
				this.elem.removeEventListener('mousedown',  this.fn.startMouse);
				this.elem.removeEventListener('mousemove',  this.fn.move);
				this.elem.removeEventListener('mouseleave', this.fn.end);
				 document.removeEventListener('mouseup',    this.fn.end);
			}

			if (this.args.addDragDropEvents) {
				this.elem.removeEventListener('dragstart', this.fn.startDragDrop);
				this.elem.removeEventListener('dragleave', this.fn.end);
				this.elem.removeEventListener('dragexit',  this.fn.end);
				this.elem.removeEventListener('drop',      this.fn.end);
			}
		}

		registerEvents() {
			this.fn = {
				startDragDrop: this.startDragDrop.bind(this),
				startMouse:    this.startMouse.bind(this),
				startTouch:    this.startTouch.bind(this),
				move:          this.move.bind(this),
				end:           this.end.bind(this),
			};

			this.elem.addEventListener('touchstart', this.fn.startTouch, { passive: true });
			this.elem.addEventListener('touchmove',  this.fn.move, { passive: true });
			this.elem.addEventListener('touchend',   this.fn.end);

			if (this.args.addMouseEvents) {
				this.elem.addEventListener('mousedown',  this.fn.startMouse);
				this.elem.addEventListener('mousemove',  this.fn.move);
				this.elem.addEventListener('mouseleave', this.fn.end);
				 document.addEventListener('mouseup',    this.fn.end);
			}

			if (this.args.addDragDropEvents) {
				this.elem.addEventListener('dragstart', this.fn.startDragDrop);
				this.elem.addEventListener('dragleave', this.fn.end);
				this.elem.addEventListener('dragexit',  this.fn.end);
				this.elem.addEventListener('drop',      this.fn.end);
			}
		}

		startTouch(event) {
			this.active    = true;
			this.eventType = 'touch';
			this.lastPos   = this.getPosition(event);
		}

		startMouse(event) {
			this.active    = true;
			this.eventType = 'mouse';
			this.lastPos   = this.getPosition(event);
		}

		startDragDrop(event) {
			this.active    = true;
			this.eventType = 'dragdrop';
			this.lastPos   = this.getPosition(event);
		}

		move(event) {
			if (!this.active) return;

			var now         = Date.now(),
				timeElapsed = now - this.lastEmit;
			if (timeElapsed < this.args.stagger) return;

			var	newPos      = this.getPosition(event),
				distance    = this.distance(this.lastPos, newPos),
				result      = {
					distance2D:  Math.sqrt(distance.x * distance.x + distance.y * distance.y),
					direction2D: Math.atan2(distance.y, distance.x),
					type:        this.eventType,
					event: 		 event
				};

			if (this.args.horizontal) {
				result.distanceX  = distance.x;
				result.directionX = Math.sign(distance.x / this.args.minDistance);
			}

			if (this.args.vertical) {
				result.distanceY  = distance.y;
				result.directionY = Math.sign(distance.y / this.args.minDistance);
			}
			
			if ((result.directionX !== 0 && this.args.horizontal) ||
				(result.directionY !== 0 && this.args.vertical)) {
				this.lastPos  = newPos;
				this.lastEmit = now;

				this.callback(result);
			}
		}

		end(event) {
			this.active = false;
		}

		getPosition(event) {
			var pos = this.eventType == 'touch' ? event.touches[0] : event;
			return { x: pos.clientX, y: pos.clientY };
		}

		distance(pos1, pos2) {
			return { x: pos1.x - pos2.x, y: pos1.y - pos2.y };
		}
	}



	init();
})();